import { datadogLogs } from '@datadog/browser-logs';
import { getEnvironmentId } from './utils/getEnvironmentId';

const clientToken = 'pub980ac3345f76d59f07e84bd74b4733c4',
    serviceName = 'insights',
    sampleRate = 100;

// todo: this is to be reviewed. This pattern has been applied to datadogRum configuration
// if (environmentID === 'live') {
//     sampleRate = 5;
// }

datadogLogs.init({
    clientToken: clientToken,
    site: 'datadoghq.eu',
    env: getEnvironmentId(),
    service: serviceName,
    forwardErrorsToLogs: false,
    sampleRate: sampleRate
});

window.datadogLogs = datadogLogs;
